module.exports = __webpack_public_path__ + "static/media/IMG_0421.22f2d55c.JPG";